<template>
  <div class="lpy-app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- <div v-if="showHashcodeNotice" class="hascode-notice">
      <van-notice-bar wrapable mode="closeable" :scrollable="false" @close="handleNoticeClose" @click="handleNoticeClose">
        <van-icon name="info" />
        <div>温馨提示：当前页面需要更新，请点击此处刷新！</div>
      </van-notice-bar>
    </div> -->
    <!-- login box -->
    <AppLogin :backUrl="backUrl" @login="loginOK" ref="loginDialog" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from 'jyutils/tools';
import AppLogin from '@/web/app-login.vue';
export default {
  name: 'app',
  componentName: 'index',
  components: { AppLogin },
  mixins: [tools],
  data () {
    return {
      backUrl: '',
      websocket: null,
      timeWebsocket: null,
      showHashcodeNotice: false,
      new_hashCode: null
    }
  },
  computed: {
    ...mapState(['c_token']),
    ...mapGetters(['settings']),
  },
  watch: {
    c_token(val) {
      if (this.websocket && this.websocket.readyState === 1) {
        let params = { token: this.$store.state.c_token };
        this.websocket.send(JSON.stringify(params));
      }
    },
    'settings.title'(val) {
      if (val) {
        document.title = val;
      }
    }
  },
  created () {
    // axios 请求拦截
    this.$axios.interceptors.request.use((config) => {
      // 检查登录状态及token
      // this.$store.commit(types.JY_LOGIN_CHECK);
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    // axios 响应拦截
    this.$axios.interceptors.response.use((response) => {
      let json = response.data;
      if (json && json[types.KEY_STATUS] && json[types.KEY_STATUS] === types.CODE_TIMEOUT) {
        this.doLogin({backUrl: this.$route.path});
        // this.$store.commit(types.JY_LOGOUT);
      }
      return response;
    }, (error) => {
      return Promise.reject(error);
    });

    let router = this.$router;
    if (router) {
      // 导航钩子 - before - 验证登录
      router.beforeEach((to, from, next) => {
        // 查询路由元信息，如果需要登录则跳转到登录页面
        if (to.matched.some(record => record.meta.hasAuth)) {
          if (this.member.id) {
            next()
          } else {
            next(false);
            // 登录
            this.doLogin({backUrl: this.$route.path});
          }
        } else {
          next()
        }
      });
    }

    this.$on('login', this.doLogin);
    this.$on('logout', this.doLogout);
    this.$on('timeout', () => {
      this.doLogin({backUrl: this.$route.path});
    });
  },
  mounted () {
    this.$store.dispatch(types.JY_TOKEN_GET, () => {
    });
    this.doGet({
      url: 'vue/home/setting',
      okcb: (json) => {
        this.$store.commit('setSetting', json);
      }
    });
    if (this.settings.title) {
      document.title = this.settings.title;
    }
    this.timerWebsocket = setInterval(() => {
      this.connWebscoket();
    }, 1000);
  },
  beforeDestroy () {
    this.websocket && this.websocket.close();
  },
  methods: {
    socketHashcode() {
      if (this.websocket && this.websocket.readyState === 1) {
        let params = { type: 'hashcode.check', token: this.c_token };
        this.websocket.send(JSON.stringify(params));
      }
    },
    connWebscoket() {
      // websocket
      if (!this.websocket || this.websocket.readyState > 1) {
        this.websocket = new WebSocket(this.$axios.defaults.wsroot +"/msg.ws");
      }
      if (this.websocket) {
        if (this.timerWebsocket) {
          clearInterval(this.timerWebsocket);
        }
        this.doWebscoket();
      }
    },
    doWebscoket() {
      //连接成功建立的回调方法
      this.websocket.onopen = () => {
        // 检查hashcode, 判断是否需要reload
        this.socketHashcode();
      }
      // websocket - onmessage
      this.websocket.onmessage = (event) => {
        let json = JSON.parse(event.data);
        // console.log(json)
        // 如果是更新用户
        if (json.type === 'hashcode.check') {
          // 检查hashcode, 判断是否需要reload
          if (json.settingvue.hashcode !== this.settingvue.hashcode) {
            //this.$store.dispatch(types.JY_SETTINGVUE_SET, {settingvue: json.settingvue});
            this.showHashcodeNotice = true;
            this.new_hashCode = json.settingvue;
          }
        }// 支付成功通知
        else if (json.type === 'order.paid') {
          // 通知支付页已支付成功
          this.broadcast('GoodsPay', 'order.paid');
          // 跳转
          if (this.$route.path.startWith('/goods-pay')) {
            setTimeout(() => {
              this.$router.push('/order/'+ json.orderid);
            }, 100);
          }
        }
      }
      //连接发生错误的回调方法
      this.websocket.onerror = () => {
        // console.log("WebSocket连接发生错误");
        this.websocket = null;
        this.timerWebsocket = setInterval(() => {
          this.connWebscoket();
        }, 1000);
      };
    },
    // 关闭更新通知时
    handleNoticeClose() {
      // 更新setting，刷新页面
      this.$store.commit(types.JY_SETTINGVUE_SET, {
        settingvue: this.new_hashCode,
        callback: () => {
          if (this.isWeixin) {
              let time = Date.now();
              var len = window.location.href.indexOf('?');
              if (len > 0) {
                window.location.href = window.location.href.substring(0, len) +'?'+ time;
              } else {
                window.location.href = window.location.href +'?'+ time;
              }
          } else {
            window.location.reload(true);
          }
        }
      });
    },
    doLogin(args) {
      this.backUrl = args ? args.backUrl || null : null;
      this.$refs.loginDialog.show(true);
    },
    loginOK() {
      this.$refs.loginDialog.show(false);
      this.loginLoading && this.loginLoading.close();
    }
  }
}
</script>
<style>
html{font-size:14px;}
body, input, textarea, keygen, select, button, pre{
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, Helvetica, sans-serif;
  font-size:1rem;
  font-weight:300; line-height:1.6; color:#000;
}
body{height:100%;}
p {margin:0;}
.text-center{text-align:center;}
.text-right{text-align:right;}
.app-body{margin-left:auto; margin-right:auto; max-width:800px;}
body{background-color:#fff;}
.text-orange{color:#ff6600;}
.hascode-notice {
  position:fixed;
  z-index:99999;
  left:50%;
  top:50%;
  padding:0 2rem;
  box-sizing:border-box;
  width:100%;
  max-width:800px;
  transform:translate(-50%, -50%);
}
.hascode-notice .van-notice-bar {
  box-shadow:0 0 10px 0 rgba(0,0,0,.25);
}
.hascode-notice .van-notice-bar__content {
  display:flex;
  align-items:center;
}
.hascode-notice .van-notice-bar__content .van-icon {
  margin-right:1rem;
  font-size:2rem;
}
/**  **/
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: .3;
}
</style>
<style lang="less">
.lpy-app {
  .app-body, .biz-body{
    margin:0 auto;
    max-width:@appwidth;
  }
  .van-popup {
    width:100%;
    .fixedapp();
  }
  .van-dialog {
    .fixedapp();
    transform:translate(-50%, -50%);
  }
  .van-list__finished-text {
    .flex-center();
    padding-left:2rem;
    padding-right:2rem;
    &::before, &::after {
      display:block;
      max-width:10rem;
      content:'';
      transform:scaleY(0.5);
      flex:1;
      box-sizing:border-box;
      height: 1px;
      .border-p(top, #969799);
    }
    &::before {
      margin-right:1rem;
    }
    &::after {
      margin-left:1rem;
    }
  }
}
</style>
